import { h, Component } from 'preact';
import BurgerMenu from 'components/bolt/burgerMenu/burgerMenu';
import s from 'components/bolt/overlayBackButton/overlayBackButton.sss';


export default class OverlayBackButton extends Component {

	render({ client, onClick, ariaLabel, type, burgerMenuExtraClass }) {
		const isDesktopWidth = client.isDesktopWidth;
		const maybeDesktopLineStyle = isDesktopWidth ? { background: '#212121' } : {};

		return (
			<button class={s.back} onClick={onClick} ariaLabel={ariaLabel}>
				<BurgerMenu type={type || 'back'} extraClass={burgerMenuExtraClass} lineStyle={maybeDesktopLineStyle} showtimesOverlayOpen />
			</button>
		);
	}

}

